import React, { Component } from 'react';
import Highlight, { defaultProps } from 'prism-react-renderer';
import { string, bool } from 'prop-types';

import Theme from './Theme';

export default class Code extends Component {
  static propTypes = {
    language: string,
    withLineNumbers: bool,
    codeSample: string.isRequired,
  }

  static defaultProps = {
    language: 'jsx',
    withLineNumbers: true
  }

  renderLineNumber = (i, length) => {
    if(i > 0 && i < length - 1) {
      return <span style={Theme.lineNumber}>{ i }</span>;
    }
  }

  render() {
    const { language, withLineNumbers, codeSample } = this.props;

    return (
      <Highlight {...defaultProps} theme={Theme} code={codeSample} language={language}>
        {({ className, style, tokens, getLineProps, getTokenProps }) => (
          <pre className={className} style={style}>
            {tokens.map((line, i) => (

              <div key={`line-${i}`} {...getLineProps({ line, key: i })}>
                {withLineNumbers ? this.renderLineNumber(i, tokens.length) : null}

                {line.map((token, key) => (
                  <span key={`token-${i}`} {...getTokenProps({ token, key })} />
                ))}
              </div>
            ))}
          </pre>
        )}
      </Highlight>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Code/Code.js